

    
export type AddressType = 'General' | 'InternalDelivery' | 'Doctor' | 'Institution';

export const AddressType = {
    General: 'General' as AddressType,
    InternalDelivery: 'InternalDelivery' as AddressType,
    Doctor: 'Doctor' as AddressType,
    Institution: 'Institution' as AddressType
};

